import React, { useState, useEffect } from 'react';
import { Badge, Cards, Grid, Link, Modal, StatusIndicator } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { APIProvider, AdvancedMarker, Map } from '@vis.gl/react-google-maps';
import Icon from '@mdi/react';
import { mdiPin, mdiInfinity, mdiAllInclusiveBox } from '@mdi/js';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
export const ConfigAccessesPage = () => {
  const storeAdmin = useStoreAdmin();
  const { idPropiedad } = useGlobalState();
  const { JWT } = useGlobalState();
  const [loadingMain] = useState(false);
  const [isMapOpen, setIsMApOpen] = useState(false);
  const [mapUrl, setMapUrl] = useState('');
  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [accesses, setAccesses] = useState<AccessItem[]>([]);
  const { setLoading } = useGlobalState();

  type AccessItem = {
    idAcceso: number;
    deviceFWVersion: number;
    allowDistanceOpen: number;
    deviceOnline: number;
    acceso: string;
    device: string;
    deviceModel: string;
    deviceHostType: string;
    direccion: string;
    deviceShadow: any;
    lat1: number;
    lon1: number;
    relay: number;
  };
  const handleMapBtn = (item: AccessItem) => {

    const url = `https://maps.googleapis.com/maps/api/staticmap?center=${item.lat1},${item.lon1}&zoom=13&size=800x400&markers=color:green%7Clabel:A%7C${item.lat1},${item.lon1}&key=AIzaSyArNTcY1e_oLKgply89Mx2NySzONuIsYYc`
    setMapUrl(url)
    setIsMApOpen(true)
  };
  const handleRefresh = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/properties/accesses/list',
          'JWT': JWT,

        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);

      setAccesses(data.accesses);

    } catch (error) {
      console.error('Error fetching accesses:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    handleRefresh();
  }, []);

  return (
    <CustomAppLayout
      toolsHide={true}
      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Configuración', href: '#config/default' },
            { text: 'Accesos', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <Cards
            loading={loadingMain}
            //selectionType="single"
            //onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
            cardDefinition={{

              header: item => <>
                <Link href={`#config/access.edit?id=${item.idAcceso}`}>{item.acceso}</Link>
                <Box float='right'>
                  {item.relay === 0 ? (
                    <Badge color="grey">Virtual</Badge>
                  ) : (
                    <Badge color={item.deviceOnline === 1 ? "green" : "red"}>
                      {item.deviceOnline === 1 ? "Conectado" : "Desconectado"}
                    </Badge>
                  )}
                </Box>

              </>
              ,
              sections: [
                {
                  header: null, // Remove the header for this combined section
                  content: (item) => (
                    <Grid gridDefinition={[{ colspan: { default: 12 } }]}>
                      <LoadScript googleMapsApiKey="AIzaSyArNTcY1e_oLKgply89Mx2NySzONuIsYYc">

                        <GoogleMap
                          mapContainerStyle={{ width: '100%', height: '200px' }}
                          center={{ lat: item.lat1, lng: item.lon1 }}
                          zoom={13}
                          id={`mp${item.idAcceso}`}
                          options={{
                            disableDefaultUI: true,
                            zoomControl: false,
                            streetViewControl: false,
                            mapTypeControl: true,
                            fullscreenControl: false,
                            draggable: false,
                            scrollwheel: false,
                            disableDoubleClickZoom: true
                            //gestureHandling: 'none',
                          }}
                        >

                          <Marker position={{ lat: item.lat1, lng: item.lon1 }}></Marker>
                        </GoogleMap>
                      </LoadScript>

                    </Grid>
                  ),
                },
                {
                  header: null, // Remove the header for this combined section
                  content: (item) => (
                    <Grid gridDefinition={[{ colspan: { default: 6 } }, { colspan: { default: 6 } }]}>
                      <div>
                        <b>ID</b>:<br></br> {item.idAcceso}
                      </div>
                      <div>
                        <b>Tipo</b>:<br></br> {item.deviceHostType}
                      </div>
                    </Grid>
                  ),
                },
                {
                  header: null, // Remove the header for this combined section
                  content: (item) => (
                    <Grid gridDefinition={[{ colspan: { default: 6 } }, { colspan: { default: 6 } }]}>
                      <div>
                        <b>Dist mínima</b>:<br />
                        {item.allowDistanceOpen >= 0 ? (
                          `${item.allowDistanceOpen}m`
                        ) : (
                          <>
                            <Icon path={mdiAllInclusiveBox} size={1} /> Ilimitada
                          </>
                        )}
                      </div>
                      <div>
                        <b>Dispositivo</b>:<br />
                        {item.relay === 0 ? "VIRTUAL" : item.device}
                      </div>
                    </Grid>
                  ),
                },
                {
                  header: "Ubicación",
                  content: (item) => (<>{item.direccion} <Link onClick={() => handleMapBtn(item)}><Icon path={mdiPin} size={1}></Icon></Link></>),
                },
              ],
            }}


            cardsPerRow={
              [{
                cards: 1
              }, {
                minWidth: 600,
                cards: 2
              }, {
                minWidth: 1000,
                cards: 3
              }]
            }
            //entireCardClickable
            items={accesses}
          //header={<Header><Icon name="script"></Icon> Opciones</Header>}
          />
          <Modal
            visible={isMapOpen}
            onDismiss={() => setIsMApOpen(false)}
            header="Ubicación"
            size="medium"
          >
            <img src={mapUrl} alt="Imagen" style={{ maxWidth: '100%', maxHeight: '80vh', display: 'block', margin: '0 auto' }} />
          </Modal>
        </>
      }
    />
  );
};
